import { Vehicle } from "../../types/vehicle.type";
import { STRIPE_BACKGROUND } from "../Product/shared/constants";
import { fuelTypeLabel } from "./vehicleForm";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const EMPTY_PLACEHOLDER = "-";
const SKELETON_ROW_COUNT = 5;

const COLUMNS = [
  "ลำดับ",
  "ป้ายทะเบียน",
  "ประเภทรถ",
  "รุ่นรถ/ยี่ห้อรถ",
  "ประเภทเครื่องยนต์",
  "ปริมาตรถังน้ำมัน (ลิตร)",
  "การดำเนินการ",
];

const formatCapacity = (capacity: string | null): string =>
  capacity === null ? EMPTY_PLACEHOLDER : String(Number(capacity));

interface VehicleRowProps {
  vehicle: Vehicle;
  no: number;
  onEdit: (vehicle: Vehicle) => void;
}

function VehicleRow({ vehicle, no, onEdit }: VehicleRowProps) {
  const handleEdit = () => onEdit(vehicle);

  return (
    <TableRow sx={{ bgcolor: no % 2 === 0 ? STRIPE_BACKGROUND : "#fff" }}>
      <TableCell align="center">{no}</TableCell>
      <TableCell>{vehicle.vehicle_plate}</TableCell>
      <TableCell>{vehicle.vehicle_type || EMPTY_PLACEHOLDER}</TableCell>
      <TableCell>{vehicle.model || EMPTY_PLACEHOLDER}</TableCell>
      <TableCell>
        {fuelTypeLabel(vehicle.fuel_type) || EMPTY_PLACEHOLDER}
      </TableCell>
      <TableCell align="right">{formatCapacity(vehicle.capacity)}</TableCell>
      <TableCell>
        <Tooltip title="แก้ไข">
          <IconButton size="small" color="primary" onClick={handleEdit}>
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

const renderSkeletonRows = () =>
  Array.from({ length: SKELETON_ROW_COUNT }).map((_, rowIndex) => (
    <TableRow key={rowIndex}>
      {COLUMNS.map((column) => (
        <TableCell key={column}>
          <Skeleton variant="text" />
        </TableCell>
      ))}
    </TableRow>
  ));

interface VehicleTableProps {
  vehicles: Vehicle[];
  loading: boolean;
  onEdit: (vehicle: Vehicle) => void;
}

export default function VehicleTable({
  vehicles,
  loading,
  onEdit,
}: VehicleTableProps) {
  const isEmpty = !loading && vehicles.length === 0;

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead
            sx={{ bgcolor: (theme) => theme.palette.background.default }}
          >
            <TableRow>
              {COLUMNS.map((column) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && renderSkeletonRows()}
            {!loading &&
              vehicles.map((vehicle, index) => (
                <VehicleRow
                  key={vehicle.uuid}
                  vehicle={vehicle}
                  no={index + 1}
                  onEdit={onEdit}
                />
              ))}
            {isEmpty && (
              <TableRow>
                <TableCell colSpan={COLUMNS.length} align="center">
                  ยังไม่มีรถในสาขานี้
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
